/** Backend message for a recording with no transcribable speech (music, ambient sound,
 *  silence) — set identically by both `generate_prompt_report` and the direct TRANSCRIPT
 *  populate path in `services/prompt_reports/tasks.py`. Retrying can't fix this: the
 *  source audio itself has nothing to transcribe. */
const NO_SPEECH_MESSAGE = "No transcript text available";

export interface ReportFailureMessage {
  title: string;
  detail?: string;
}

/** Maps a PromptReport's `error_message` to what the failed-report card should show,
 *  swapping in an accurate explanation for the well-understood "no speech in the
 *  recording" case instead of a generic message that implies retrying will help. */
export function describeReportFailure(errorMessage?: string | null): ReportFailureMessage {
  if (errorMessage === NO_SPEECH_MESSAGE) {
    return {
      title: "No speech detected in this recording",
      detail:
        "This can happen with music, ambient sound, or silence — there's no dialogue to build a report from. Retry only helps if this was a transient error; different audio needs a fresh upload.",
    };
  }

  return {
    title: "Report generation failed. Please try again.",
    detail: errorMessage || undefined,
  };
}
